import { render, staticRenderFns } from "./Badge10.vue?vue&type=template&id=ada19394&scoped=true"
import script from "./Badge10.vue?vue&type=script&lang=js"
export * from "./Badge10.vue?vue&type=script&lang=js"
import style0 from "./Badge10.vue?vue&type=style&index=0&id=ada19394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada19394",
  null
  
)

export default component.exports